/* lua.js generated code 0.3.0 */
var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")


var BagHelpPanel = xClass("BagHelpPanel", BasePanel, function () {
    FrameLoader.loadImageWithPlist("cocos/bag.plist")
    return cc.CSLoader.createNode(`cocos/bag_bag_info.csb`)
})

BagHelpPanel.prototype.ctor = function () {
    var self = this;
    BasePanel.prototype.ctor.call(self)
    self.initUI()
}
BagHelpPanel.prototype.initUI = function () {
    let self = this
    let closeBtn = UIButton.create(this.getChildByName("com_close"));
    PushBounceAnim.create(closeBtn)
    closeBtn.on(UIButtonEvent.Click, ()=>{
        this.onClose()
    });

    var txt = self.getChildByName("content").getChildByName("txt")
    var text = txt.getString()
    var c = text.replace(/\\n/g, "\n")
    txt.setString(c)
    txt.setPositionY(self.getChildByName("content").getChildByName("com_bg_small").getPositionY())

    var title = self.getChildByName("com_title").getChildByName("txt_title")
    title.setPositionY(23)
}

module.exports = BagHelpPanel
